export default {
    'estimated_quotation': 'ESTIMATED QUOTATION',
    urlBuses: '/'
}